import { render, staticRenderFns } from "./AppActionsMenu.vue?vue&type=template&id=2562729a&scoped=true&"
import script from "./AppActionsMenu.vue?vue&type=script&lang=js&"
export * from "./AppActionsMenu.vue?vue&type=script&lang=js&"
import style0 from "./AppActionsMenu.vue?vue&type=style&index=0&id=2562729a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2562729a",
  null
  
)

export default component.exports